
import './style/base-style.css'
import kaltIcon from './images/images-rentApp/Kalt.svg' 
import warmIcon from './images/images-rentApp/Warm.svg'
import arrow1 from './images/images-rentApp/arrow1.svg'
import heartIcon from './images/images-rentApp/heart-icon.svg'
import barsIcon from './images/images-rentApp/bars-icon.svg'
import gridIcon from './images/images-rentApp/gridIcon.svg'
import listIcon from './images/images-rentApp/list-icon.svg'
import filterIcon from './images/images-rentApp/filter-icon.svg'
import searchIcon from './images/images-rentApp/search-icon.svg'
import downArrow from './images/images-rentApp/downArrow.svg'
import checkIcon from './images/images-rentApp/check-icon.svg'
import plusIcon from './images/images-rentApp/plus-icon.svg'

import {useState} from 'react'
import React, { useRef } from 'react';

import FilterPopup from './FilterPopup'

export default function Table({apparts}){


    const Amenities = ({ amenities }) => (
        <div className='amenPills'>
            {amenities.map(amenity => {
            if (amenity === 'furnished') return <div key={amenity} className='purplePill'>{amenity}</div>;
            if (amenity === 'kitchen') return <div key={amenity} className='redPill'>{amenity}</div>;
            if (amenity === 'parking') return <div key={amenity} className='greenPill'>{amenity}</div>;
            return null;
            })}
        </div>
        );

        const Price = ({price})=>{

        if (price[0] === 'kalt') return <div className='TPriceBlue'><img src={kaltIcon}/>{price[1]}</div>
        if (price[0] === 'warm') return <div className='TPriceRed'><img src={warmIcon}/>{price[1]}</div>
    };
            
    const [BgColor, setBgColor] = useState('#dedede')
    const [HoverIndex, setHoverIndex] = useState('')
    const [ClickIndex, setClickIndex] = useState(0)
    const HeartColor = 'invert(28%) sepia(100%) saturate(9000%)'
    const [ClickedFav, setClickedFav] = useState([])
    const [ClickedRow, setClickedRow] = useState([])
    const [RowFtWeight, setRowFtWeight] = useState('600')

    const RowColor = ' #F7ECFF '

    const handleRowHover = (index) => {
        setHoverIndex(index);
    }
    const handleRowLeave = (index) => {
        setHoverIndex('');
    }

    const handleLikeClick = (index) => {

        let found = false
        for (let i = 0; i < ClickedFav.length; i++) {
            if (ClickedFav[i] === index) {
                found = true;
                ClickedFav.splice(i, 1)
                setClickedFav([...ClickedFav]);
                break;
            }
        }
        if (!found) {
            setClickedFav([...ClickedFav, index]);
        }
    }
    const handleRowClick = (index) => {
        let found = false
        for (let i = 0; i < ClickedRow.length; i++) {
            if (ClickedRow[i] === index) {
                found = true;
                ClickedRow.splice(i, 1)
                setClickedRow([...ClickedRow]);
                break;
            }
        }
        if (!found) {
            setClickedRow([...ClickedRow, index]);
        }
    }


    const [GridIconColor, setGridIconColor] = useState(['#f4f4f4', '.5'])
    const [ListIconColor, setListIconColor] = useState(['#f4f4f4', '.5'])
    let anyth = false

    const handleToggleHover = (icon) => {
        
        icon  === 'grid' ? setGridIconColor(['#ffffff', '.8']) :  anyth = false
        icon  === 'list' ? setListIconColor(['#ffffff', '.8'])  :  anyth = false
        }
    const handleToggleLeave = (icon) => {

        icon  === 'grid' ? setGridIconColor(['#f4f4f4', '.5']) :  anyth = false
        icon  === 'list' ? setListIconColor(['#f4f4f4', '.5']):  anyth = false
        }

        let count = 0;

        document.addEventListener('click', function(event) {
            const dropDownDisplay = document.querySelector('.dropDown')
            const sortByDiv = document.querySelector('#SortBy')
            const filterButton = document.querySelector('#filterButton')


            if (!sortByDiv.contains(event.target) && !dropDownDisplay.contains(event.target)) {
                dropDownDisplay.style.display = 'none'
            } 
            

            {/*            if (filterMainRef.current !== null){
                count+=1
                console.log(count)
                console.log('filterMainRef created') // Logs the div with id="filterMainTag"
                
                if (!filterMainRef.current.querySelector('.filterContainer').contains(event.target) && count > 1) {

                    count = 0
                    setFilterPop(false)

                    
                } }

            console.log((event.target))*/}

            

            })



        function DropDown () {
        return(

            <div className='dropDown'>
                <button class="closeButton" onClick={(() => document.querySelector('.dropDown').style.display = 'none')}>&times;</button>
                <a className='dropButton' >Price: low to high</a>
                <a className='dropButton'>Price: high to low</a>
                <a className='dropButton'>Free from: closest date</a>
                <a className='dropButton'>Free from: farthest date</a>
                <a className='dropButton'>Newest first</a>
            </div>
        )
    }

    const [FilterPop, setFilterPop] = useState(false)
    const filterMainRef = useRef(null);

        

        return (   

            <div   id='TableContainer' style={{'display':'flex', 'flex-direction': 'column', 'justify-content': 'center', 'align-items': 'center', 'width': '100%'}}>
                
                {FilterPop && <FilterPopup setFilterPop= {setFilterPop} ref={filterMainRef}/>}
               
                <div id='FiltersContainerDiv'  style={{ 'display':'flex', 'align-items': 'center', gap: '11px', 'width': '1444px'}}>

                    <div id="emptyBox"  style={{ 'width':'95px'}} />

                    <div className='filtersDiv'>

                        <div className='sortPill' style={{'cursor': 'default', 'justify-content': 'left'}}>
                            <img src={searchIcon} style={{filter: 'invert(49%)', transform: 'scale(.9) translateY()'}}/> 
                            <input className='searchTable'  placeholder=' Search'/>
                        </div>

                        <div className='filterButtons'>

                            <div className='sortPill' id='filterButton' onClick={(()=> setFilterPop(!FilterPop))}>
                                <img src={filterIcon}/> Filter
                            </div>

                            <div className='sortPill' id='SortBy' style={{ 'min-width': '83px'}} onClick={(() => document.querySelector('.dropDown').style.display = 'flex')}>
                                <img src={barsIcon}/> Sort by <img src={downArrow}/>     
                            </div>
                            <div style={{position: 'absolute', top:'45px', right:'85px', 'z-index': '33'}}><DropDown/></div>

                            <div className='pillToggle'>
                                <img src={gridIcon} onMouseEnter={(() => handleToggleHover('grid'))} onMouseLeave={(() => handleToggleLeave('grid'))} style={{'background-color': GridIconColor[0], 'opacity': GridIconColor[1], transform: 'rotate(180deg)'}}/>
                                <img src={listIcon} onMouseEnter={(() => handleToggleHover('list'))}  onMouseLeave={(() => handleToggleLeave('list'))} style={{'background-color': ListIconColor[0], 'opacity': ListIconColor[1]}}/>

                            </div>
                        </div>
                        
                    </div>
                </div>
                    
            
                <div id='Two-Tables-Flex' style={{'display':'flex', 'width': '1444px'}}>                   

                    {/*LINKE BUTTON*/}
                    <table>
                        <thead>
                            <tr style={{'border': 'none', 'height': '53px', 'opacity': '0'}}>
                                <th>like b</th>
                            </tr>
                            </thead>

                        <tbody>
                            
                        {apparts.list.map((item, index) => (
                                <tr style={{'background-color': 'rgba(255,255,0,0)', border: 'none'}} onMouseEnter={(()=> {handleRowHover(index)})} onMouseLeave={(()=> {handleRowLeave(index)})} onClick={()=>{handleLikeClick(index)}}>
                                    <td><div className='likeButton' style={{opacity: index === HoverIndex ? '1' : '0'}}><img src={heartIcon} style={{ filter: ClickedFav.includes(index) ? HeartColor : '' }} 
                            /></div></td>
                                </tr>
                            ))}

                        </tbody>

                    </table>

                    {/*OFFER ROWS*/}
                    <table>
                        <thead>
                            <tr style={{'border': 'none', 'height': '53px'}}>
                                <th style={{ 'border-radius': '20px 0 0 0'}}>Date</th>
                                <th>Title</th>
                                <th>Location</th>
                                <th>Type</th>
                                <th>Amenities</th>
                                <th>Duration</th>
                                <th>Available</th>
                                <th style={{'border-radius': '0 20px 0 0'}}>Price</th>
                            </tr>
                        </thead>
                        <tbody >
                            {apparts.list.map((item, index) => (
                                <tr onMouseEnter={(()=> {handleRowHover(index)})} onMouseLeave={(()=> {handleRowLeave(index)})} style={{'background-color': index === HoverIndex ? RowColor : ClickedRow.includes(index) ? '#fbfbfb' : '#ffffff', 'font-weight': ClickedRow.includes(index) ? '400' : '600' }}  onClick={()=>{handleRowClick(index)}} >
                                    <td>{item.date}</td>
                                    <td>{item.title}</td>
                                    <td>{item.location}</td>
                                    <td>{item.type}</td>
                                    <td><Amenities amenities={item.amenities} /></td>
                                    <td>{item.duration}</td>
                                    <td>{item.available}</td>
                                    <td style={{'display': 'flex', 'align-items': 'center', 'gap': '11px'}}><Price price={item.price}/><div className='circleButtonDark'><img src={arrow1}/></div></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                </div>
            </div>
    );
}